module.exports = __webpack_public_path__ + "media/images/past_order_history/btn_Order_2_01-5c234e5a72ea10b35a999f9c2ff6a68d.png";